import React from "react";
import CustomButton from "../common/button/CustomButton";
import DisabledTooltipWrap from "../common/disabled-tooltip-wrap/DisabledTooltipWrap";
import theme from "../../theme";
import CreateShipmentSvg from "../../assets/Icons/Create";
import { StyledBox, StyledStatusMessage, StyledTypography } from "./style";

const CustomHeader = ({
  title,
  label,
  onClick,
  disabled = false,
  disabledReason,
  statusMessage,
}) => {
  return (
    <StyledBox>
      <StyledTypography>{title}</StyledTypography>
      {statusMessage ? (
        <StyledStatusMessage>{statusMessage}</StyledStatusMessage>
      ) : null}
      <DisabledTooltipWrap title={disabledReason} disabled={disabled}>
        <CustomButton
          fontSize={theme.typography.small.fontSize}
          startIcon={<CreateShipmentSvg width={20} height={20} />}
          btntype="warning"
          btnLabel={label}
          onClick={onClick}
          disabled={disabled}
        />
      </DisabledTooltipWrap>
    </StyledBox>
  );
};

export default CustomHeader;
